export default "__VITE_ASSET__tVNfJAg5__"